<template>
  <div class="card"
       v-if="showComponent"
       :title="qaAble ? showIfHasPermission?.toString() : null"
       :key="componentRefresh"
       :class="[containerClasses]"
       :style="{
            'height': cardHeight,
            'max-height': cardHeight, 
            'min-height':  cardHeight,
            'width': cardWidth,
            'padding': cardPadding,
            'overflow': 'hidden'
        }"
  >
    <ks-search
        v-if="showDefaultSearch && (hideOnScreenSizeChange ? screenSizeId < 3 : true)"
        :preAndPostPend="preAndPostPend"
        :showSelectedInButton="showSelectedInButton"
        :modeOptions="modeOptions"
        :defaultModeInclude="defaultModeInclude"
        :defaultSearchWidth="defaultSearchWidth"
        :searchPlaceholder="searchPlaceholder"
        :dataProvider="dataProvider"
        inputStyles="margin-top: 10px;"
        :modeCodeId="modeCodeId"
    />
    <div
        class="card-header d-flex flex-row justify-content-between align-items-center"
        :class="[headerClasses]" v-if="title || hasSlotHeader"
        style="height: 70px; min-height: 70px; max-height: 70px; padding-top: 25px; padding-right: 25px; padding-left: 12px;"
    >
      <h5
          class="mb-0"
          v-if="title">
        {{ title }}
      </h5>
      <slot
          name="header"
      />
    </div>
    <slot/>
    <div
        class="card-body"
        :class="[bodyClasses]"
        :style="{
                'padding': bodyPadding,
                'overflow-y': scrollY ? 'scroll' : 'hidden', 
                'overflow-x': scrollX ? 'scroll' : 'hidden' 
            }"
        v-if="hasSlotBody"
    >
      <slot
          name="body"
      />
    </div>
    <div
        class="card-footer"
        :class="[footerClasses]" v-if="hasSlotFooter"
    >
      <slot
          name="footer"
      />
    </div>
  </div>
</template>

<script>
import checkPermissions from '../../mixins/checkPermissions';

export default {
  name: "ks-card",
  mixins: [checkPermissions],
  props: {
    showDefaultSearch: {type: Boolean, default: false}
    , title: {type: String, default: null}
    , classes: {type: String, default: ''}
    , shadow: {type: Boolean, default: true}
    , headerClasses: {type: String, default: ''}
    , bodyClasses: {type: String, default: ''}
    , footerClasses: {type: String, default: ''}
    , cardHeight: {type: String, default: null}
    , cardWidth: {type: String, default: null}
    , scrollY: {type: Boolean, default: true}
    , scrollX: {type: Boolean, default: true}
    , cardPadding: {type: String, default: 'none'}
    , bodyPadding: {type: String, default: '10px'}
    , preAndPostPend: {type: Boolean, default: false}
    , modeCodeId: {type: String, default: null}
    , showSelectedInButton: {type: Boolean, default: true}
    , modeOptions: {type: Array, default: () => []}
    , defaultModeInclude: {type: String, default: null}
    , searchPlaceholder: {type: String, default: 'Search...'}
    , defaultSearchWidth: {type: String, default: '400px'}
    , hideOnScreenSizeChange: {type: Boolean, default: true}
  },
  mounted() {
    if (this.$parent.multiCampaign) {
      this.multiCampaign = this.$parent.multiCampaign;
    }
  },
  computed: {
    screenSizeId() {
      return app.layout.screenSizeId;
    },
    data_provider_ref() {
      return this.$parent.data_provider_ref ? this.$parent.data_provider_ref : {};
    },
    dataProvider() {
      return this.$parent.dataProvider ? this.$parent.dataProvider : null;
    },
    type() {
      return this.$parent.type ? this.$parent.type : null;
    },
    containerClasses() {
      let shadow = this.shadow === true ? 'shadow' : '';
      return `${this.classes} ${shadow}`;
    },
    hasSlotHeader() {
      return !!this.$slots.header;
    },
    hasSlotBody() {
      return !!this.$slots.body;
    },
    hasSlotFooter() {
      return !!this.$slots.footer;
    },
    qaAble: {
      get: () => {
        return app.store.state.ks_app.global_data.qaAble;
      }
    }

  },
  data() {
    return {
      multiCampaign: null
    }
  }
}
</script>
